'use client';

import { Box, Stack } from '@mui/material';
import ScrollProgress from '@/app/components/scroll-progress';
import MasterLayout from '@/app/components/layout/master-layout';
import DeviceManageLayout from '@/app/components/layouts/device-manage';
import { TermsAndConditionsContent } from './terms-and-conditions';

export default function TermsAndConditions() {
  return (
    <MasterLayout>
      <ScrollProgress />
      <DeviceManageLayout
        title="Terms And Conditions"
        description="Our terms ensure clarity and fairness, guiding your use of our services with trust and transparency."
      >
        <Box
          sx={{
            mx: 'auto',
            width: {
              md: '100%',
              lg: '1200px',
            },
            pl: 3,
            pr: 3,
          }}
        >
          <Stack gap={8}>
            <TermsAndConditionsContent />
          </Stack>
        </Box>
      </DeviceManageLayout>
    </MasterLayout>
  );
}
